<template>
  <div class="container">
    <slot />
  </div>
</template>
<script>


export default {
  components: {

  },
  data() {
    return {

    };
  },
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
  .container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    overflow: hidden;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/FixedContainer.vue